import React from 'react'
import { FormattedMessage } from 'react-intl'

import styles from './styles.module.css'
import messages from './messages'
import cn from 'classnames'

interface IratingsReviewCountProps {
  count: number
}

const RatingReviewsCount = ({ count }: IratingsReviewCountProps) => {
  return (
    <span className={cn(styles.reviewsCountBase)}>
      <span className={styles.description}>
        <FormattedMessage {...messages.scoreBased} />{' '}
      </span>
      <strong>
        {count} <FormattedMessage {...messages.reviews} />
      </strong>
    </span>
  )
}

export default RatingReviewsCount
